
<div class="agpr-viEngineSelector">
    <div class="agpr-viEngineSelector-sidebar">
        <ul
            role="tablist"
            [id]="id + '_engineList'"
            class="agpr-viEngineSelector-list"
            agprListKeyboardNavigation
            [focusOnChild]="true"
        >
            @if (showAllEnginesOption) {
                <li
                    role="tab"
                    [id]="id + '_engineListItem_all'"
                    class="agpr-viEngineSelector-listItem"
                    [pTooltip]="'Vi.answerEngineType.all' | localize"
                    tooltipPosition="right"
                >
                    <agpr-button
                        [id]="id + '_engineButton_all'"
                        class="agpr-viEngineSelector-listItem-button agpr-viEngineSelector-listItem-button--all"
                        [ngClass]="{
                            'agpr-viEngineSelector-listItem-button--selected': isAllSelected,
                            'agpr-viEngineSelector-listItem-button--unselected': !isAllSelected,
                            'agpr-viEngineSelector-listItem-button--loading': isAnyEngineLoading,
                            'agpr-viEngineSelector-listItem-button--unavailable': isAllUnavailable
                        }"
                        [agprLoading]="isAnyEngineLoading"
                        icon="fa-regular fa-rectangle-history"
                        (click)="select(null)"
                    >
                        @if (isAllUnavailable) {
                            <span class="fa-solid fa-circle-exclamation agpr-viEngineSelector-listItem-buttonWarning"></span>
                        }
                    </agpr-button>
                </li>
            }
            @for (answerEngine of engines; track answerEngine.type; let i = $index) {
                @let iconTooltip = (answerEngine.label | localize);
                @let hasEngineAnswer = !!answerEngine.answerText;
                @let isUnavailable = !hasEngineAnswer && !answerEngine.loading;
                @let additionalTooltip = answerEngine.loading
                    ? ('Vi.generating' | localize)
                    : hasEngineAnswer
                        ? ''
                        : ('Vi.notAvailable' | localize);

                <li
                    role="tab"
                    [id]="id + '_engineListItem_' + answerEngine.type"
                    class="agpr-viEngineSelector-listItem"
                    [pTooltip]="iconTooltip + additionalTooltip"
                    tooltipPosition="right"
                >
                    <agpr-button
                        [id]="id + '_engineButton_' + answerEngine.type"
                        class="agpr-viEngineSelector-listItem-button"
                        [ngClass]="{
                            'agpr-viEngineSelector-listItem-button--selected': !isAllSelected && answerEngine.type === selectedEngine?.type && !answerEngine.loading,
                            'agpr-viEngineSelector-listItem-button--unselected': isAllSelected || answerEngine.type !== selectedEngine?.type,
                            'agpr-viEngineSelector-listItem-button--loading': !!answerEngine.loading,
                            'agpr-viEngineSelector-listItem-button--unavailable': isUnavailable
                        }"
                        [agprLoading]="!!answerEngine.loading"
                        (click)="select(answerEngine.type)"
                    >
                        <img
                            class="agpr-viEngineSelector-listItem-buttonIcon"
                            [src]="appBaseHref + answerEngine.logoUrl"
                            alt="AI Logo"
                            aria-hidden="true"
                        />

                        @if (isUnavailable) {
                            <span class="fa-solid fa-circle-exclamation agpr-viEngineSelector-listItem-buttonWarning"></span>
                        }
                    </agpr-button>
                </li>
            }
        </ul>
    </div>

    <div
        role="tabpanel"
        [id]="id + '_content'"
        class="agpr-viEngineSelector-content"
        [agprLoading]="isLoading"
    >
        <ng-content></ng-content>
    </div>
</div>
